import { useLang, useT } from "@/i18n";
import { LEGAL } from "@/i18n/legal";
import { useSeo } from "@/hooks/useSeo";

/** Renders a policy page from the LEGAL copy in the active language. */
export const LegalPage = ({ page, testId }) => {
  const lang = useLang();
  const t = useT();
  const doc = LEGAL[page][lang];

  useSeo({
    title: `${doc.title} — DirektoriBiz.my`,
    description: doc.description,
    canonical: `${window.location.origin}${window.location.pathname}`,
  });

  return (
    <div data-testid={testId} className="mx-auto max-w-3xl px-4 py-14 sm:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">DirektoriBiz.my</p>
      <h1 className="mt-3 font-display text-4xl font-bold tracking-tight sm:text-5xl">{doc.title}</h1>
      <p className="mt-2 text-sm text-slate-500">
        {t("legal.updated")}: {doc.updated}
      </p>

      <div className="mt-10 space-y-8 text-base leading-relaxed text-slate-700">
        <p>{doc.intro}</p>
        {doc.sections.map((s) => (
          <section key={s.heading}>
            <h2 className="text-base font-bold text-slate-900 md:text-lg">{s.heading}</h2>
            <div className="mt-3 space-y-3">
              {(s.paragraphs || []).map((p) => (
                <p key={p.slice(0, 40)}>{p}</p>
              ))}
              {s.list && (
                <ul className="list-disc space-y-2 pl-6">
                  {s.list.map((li) => (
                    <li key={li.slice(0, 40)}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-14 rounded-xl border border-border bg-slate-50 p-6 text-sm text-slate-600">
        <p className="font-semibold text-slate-900">YBD INFINITY GLOBAL</p>
        <p className="mt-1">
          {t("legal.regno")}: 202603212324 (JM1048394-W)
        </p>
        <p className="mt-1">
          {t("legal.email")}:{" "}
          <a href="mailto:info@direktoribiz.my" className="text-primary hover:underline">
            info@direktoribiz.my
          </a>
        </p>
      </div>
    </div>
  );
};
